import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const pageTitles: Record<string, { title: string; section: string }> = {
  '/': { title: 'Dashboard Editorial', section: 'Visão Geral' },
  '/content': { title: 'Gestão de Conteúdo', section: 'CMS' },
  '/content/new': { title: 'Novo Artigo', section: 'CMS' },
  '/ai-processing': { title: 'Processamento com IA', section: 'Inteligência Artificial' },
  '/layout-engine': { title: 'Motor de Layout', section: 'Diagramação' },
  '/export': { title: 'Exportar & Distribuir', section: 'Publicação' },
  '/settings': { title: 'Configurações', section: 'Sistema' },
};

export default function TopBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [showNotif, setShowNotif] = useState(false);

  const pageInfo = pageTitles[location.pathname] || { title: 'Página', section: '' };

  const today = new Date().toLocaleDateString('pt-BR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  const notifications = [
    { id: 1, text: 'Layout da Edição 14820 pronto para revisão', time: '5 min', type: 'info' },
    { id: 2, text: 'IA concluiu processamento de 12 artigos', time: '18 min', type: 'success' },
    { id: 3, text: 'Anúncio da AutoMax expira em 2 dias', time: '1h', type: 'warning' },
    { id: 4, text: 'Novo artigo enviado por Carlos Mendes', time: '2h', type: 'info' },
  ];

  return (
    <header className="bg-white border-b border-[#E0E0E0] flex-shrink-0 relative z-20">
      {/* Top strip — date + actions */}
      <div className="border-b border-[#E0E0E0] px-6 py-1.5 flex items-center justify-between">
        <p className="text-[11px] text-[#666666] font-sans capitalize">{today}</p>
        <div className="flex items-center gap-3">
          {/* Search */}
          <div className="relative hidden md:block">
            <i className="ri-search-line absolute left-2.5 top-1/2 -translate-y-1/2 text-[#999999] text-xs"></i>
            <input
              type="text"
              placeholder="Buscar artigos, edições..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-52 pl-7 pr-3 py-1 text-xs bg-[#F8F8F8] border border-[#E0E0E0] rounded focus:outline-none focus:border-[#111111] font-sans transition-colors"
            />
          </div>
          {/* Notifications */}
          <div className="relative">
            <button
              onClick={() => setShowNotif(!showNotif)}
              className="relative flex items-center justify-center w-7 h-7 hover:bg-[#F0F0F0] rounded cursor-pointer transition-colors"
            >
              <i className="ri-notification-3-line text-[#444444] text-sm"></i>
              <span className="absolute top-0.5 right-0.5 w-1.5 h-1.5 bg-[#C41230] rounded-full"></span>
            </button>
            {showNotif && (
              <div className="absolute right-0 top-9 w-72 bg-white border border-[#E0E0E0] z-50" style={{ boxShadow: '0 4px 16px rgba(0,0,0,0.10)' }}>
                <div className="px-4 py-2 border-b border-[#E0E0E0] flex items-center justify-between">
                  <span className="text-xs font-bold text-[#111111] font-sans uppercase tracking-wide">Notificações</span>
                  <span className="text-[10px] text-[#C41230] font-semibold cursor-pointer font-sans">Limpar</span>
                </div>
                {notifications.map((n) => (
                  <div key={n.id} className="px-4 py-2.5 hover:bg-[#F8F8F8] cursor-pointer border-b border-[#F0F0F0] last:border-0">
                    <p className="text-xs text-[#333333] font-sans leading-relaxed">{n.text}</p>
                    <p className="text-[10px] text-[#999999] mt-0.5 font-sans">há {n.time}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
          {/* Generate */}
          <button
            onClick={() => navigate('/layout-engine')}
            className="flex items-center gap-1.5 px-3 py-1 bg-[#111111] text-white text-xs font-semibold font-sans hover:bg-[#333333] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-flashlight-line text-xs"></i>
            Gerar Edição
          </button>
        </div>
      </div>

      {/* Masthead bar */}
      <div className="px-6 py-3 flex items-center gap-4">
        {/* Section label */}
        <div className="flex items-center gap-3">
          <span className="section-label">{pageInfo.section}</span>
          <span className="text-[#C8C8C8]">/</span>
          <h1 className="text-base font-bold text-[#111111] font-serif leading-none">{pageInfo.title}</h1>
        </div>
        {/* Edition badge */}
        <div className="ml-auto flex items-center gap-2 border border-[#E0E0E0] px-3 py-1">
          <i className="ri-newspaper-line text-[#999999] text-xs"></i>
          <span className="text-[11px] font-sans text-[#666666]">Edição <strong className="text-[#111111]">#14820</strong></span>
          <span className="w-1.5 h-1.5 rounded-full bg-[#C41230] animate-pulse"></span>
          <span className="text-[10px] font-semibold text-[#C41230] font-sans uppercase tracking-wide">Em Produção</span>
        </div>
      </div>
    </header>
  );
}
